export default "__VITE_ASSET__714ef607__"